module.exports = __webpack_public_path__ + "img/3_goodHealthAndWellBeing.da0c8297.png";